var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 39,
  height: 39,
  viewBox: "0 0 39 39"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Styles-v2",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  opacity: 0.6
}, /*#__PURE__*/React.createElement("g", {
  id: "Sent",
  fill: "#9B9B9B"
}, /*#__PURE__*/React.createElement("path", {
  id: "$",
  d: "M39 0 0 19.502l11.724 2.85L28.72 10.608 16.04 23.987l13.21 11.765zM14.625 39l5.294-7.199-5.294-4.715z"
})))));
export default SvgSend;